import React, { useCallback, useState } from 'react';
import Input from 'app/src/elements/inputs';
import { View, Text } from 'react-native';
import styled from 'styled-components/native';
import { useMutation } from '@apollo/client';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { CREATE_ANNOUNCEMENT } from './queries';
import { useForm } from 'react-hook-form';
import colors from '../../../styles/colors';

const AnnouncementInputContainer = styled(View)`

`;

const AnnouncementInput = ({ saleAsset, sale, setShowModal, setDisableSoldButtons }) => {
  const [submitting, setSubmitting] = useState();

  const [createAnnouncement] = useMutation(CREATE_ANNOUNCEMENT, {
    onCompleted: data => {
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    if(!input['keepBids']) {
      setDisableSoldButtons(true);
    }
    createAnnouncement({ variables: input });
  });

  const {
    control, register, handleSubmit, watch, formState: { errors }
  } = useForm({
    defaultValues: {
      assetId: saleAsset.asset.id,
      saleId: sale.id,
      body: '',
      keepBids: false
    }
  });

  const watchKeepBids = watch('keepBids');

  return (
    <AnnouncementInputContainer>
      <Input.Text
        label="Announcement:"
        name="body"
        control={control}
        errors={errors}
        {...register("body", {
          required: "Required",
        })}
      />
      {!watchKeepBids ?
        <Text style={{color: 'red', fontWeight: 'bold', marginBottom: '10px'}}>
          *Important: Sending announcement will clear all Pre Bids and Current Bids
        </Text> :
        null
      }
      <Input.Checkbox
        label="Keep Existing Bids?"
        name="keepBids"
        checked={watchKeepBids}
        control={control}
        errors={errors}
      />
      <ButtonContainer>
        <ButtonGroup>
          <Button
            label={submitting ? "Processing..." : "Send Announcement"}
            onPress={handleSubmit(onSubmit)}
            disabled={submitting}
            style={{
              backgroundColor: submitting ? colors.elLightGray : colors.elRed,
            }}
          />
        </ButtonGroup>
      </ButtonContainer>
    </AnnouncementInputContainer>
  )
}

export default AnnouncementInput;